import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './system-ai-prompt.reducer';

export const SystemAiPromptDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const systemAiPromptEntity = useAppSelector(state => state.systemAiPrompt.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="systemAiPromptDetailsHeading">
          <Translate contentKey="tycheApp.systemAiPrompt.detail.title">SystemAiPrompt</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{systemAiPromptEntity.id}</dd>
          <dt>
            <span id="promptText">
              <Translate contentKey="tycheApp.systemAiPrompt.promptText">Prompt Text</Translate>
            </span>
          </dt>
          <dd>{systemAiPromptEntity.promptText}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="tycheApp.systemAiPrompt.type">Type</Translate>
            </span>
          </dt>
          <dd>{systemAiPromptEntity.type}</dd>
          <dt>
            <Translate contentKey="tycheApp.systemAiPrompt.systemAiFunction">System Ai Function</Translate>
          </dt>
          <dd>{systemAiPromptEntity.systemAiFunction ? systemAiPromptEntity.systemAiFunction.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/system-ai-prompt" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/system-ai-prompt/${systemAiPromptEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SystemAiPromptDetail;
